import axios from 'axios';
import store from './../store';


const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL + 'api',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  config.headers['Content-Type'] = 'application/json';
  config.headers.Accept = 'application/json';
  config.headers.Authorization = `Bearer ${localStorage.getItem('_token')}`;
  return config;
});

api.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {

    const {
      response: { status, data },
    } = error;

      // let headers = {
      //   Authorization: `Bearer ${localStorage.getItem('_token')}`,
      //   Accept: 'application/json',
      //   'Content-Type': 'application/json'
      // }
      // axios.post(process.env.VUE_APP_API_URL + 'api/authentication/logout', {}, { headers })
    if (status == 401 && data.message === 'Token is Expired') {
      localStorage.removeItem('_token');
      store.dispatch('deleteUserData');
      location.reload();
    }
    if (status == 401 && data.message === 'Token is Invalid') {
      localStorage.removeItem('_token');
      store.dispatch('deleteUserData');
      location.reload();
    }
  }
);

export default api;
